import { Deserializable } from '../dtos/deserializable';
import { LoginResponseDTO } from '../dtos/responses/login-response-dto/login-response-dto';
import { UserStatus } from './user-status';
import { UserTokens } from './user-tokens';

/**
 * User model used internally by the application
 */
export class User extends Deserializable {
  /**
   * Constructor
   *
   * @param {UserStatus} status User status
   * @param {UserTokens} tokens User tokens
   */
  constructor(
    public status?: UserStatus,
    public tokens?: UserTokens,
    public email?: string,
    public imgSource?: string
  ) {
    super();
  }

  /**
   * Convert login DTO to user object
   * @param {LoginResponseDTO} dto Login response DTO
   * @return {User} Converted user object
   */
  public static fromDTO(dto: LoginResponseDTO): User {
    const user = new User();
    const tokens = new UserTokens();

    tokens.accessToken = dto.accessToken;
    tokens.refreshToken = dto.refreshToken;
    tokens.idToken = dto.idToken;

    user.status = dto.userStatus;
    user.tokens = tokens;
    user.email = dto.email;
    user.imgSource = dto.imgSource;

    return user;
  }
}
